import React from "react";
import FullMapView from "./FullMapView";

const Location = () => {
  // Assuming you have the `compInfo` object available
  const compInfo = {
    // compInfo properties here
  };

  return (
    <div style={{ height: "100vh" }}>
      <FullMapView compInfo={compInfo} />
    </div>
  );
};

export default Location;
